export enum PaperCompanies {
    AFL = "Americo",
    GSL = "GSL"
}
